import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListContractCell } from './token-list-contract.cell';
import { TokenListContractHeader } from './token-list-contract.header';

export const TokenListContractColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  unknown
> = {
  id: 'contract',
  enableSorting: false,
  header: TokenListContractHeader,
  cell: TokenListContractCell,
};
